export const LAUNCHER_CLICK_ACTION_OPEN_WIDGET = 'open_widget';
export const LAUNCHER_CLICK_ACTION_OPEN_URL = 'open_url';
export const LAUNCHER_CLICK_URL_MODE_DEFAULT = 'default';
export const LAUNCHER_CLICK_URL_MODE_CUSTOM = 'custom';

const trimValue = value => String(value || '').trim();

export const resolveLauncherClickUrlMode = source => {
  const rawMode = trimValue(source?.launcherClickUrlMode).toLowerCase();
  if (
    rawMode === LAUNCHER_CLICK_URL_MODE_DEFAULT ||
    rawMode === LAUNCHER_CLICK_URL_MODE_CUSTOM
  ) {
    return rawMode;
  }

  return trimValue(source?.launcherClickUrl)
    ? LAUNCHER_CLICK_URL_MODE_CUSTOM
    : LAUNCHER_CLICK_URL_MODE_DEFAULT;
};

export const resolveLauncherClickAction = source => {
  const rawAction = trimValue(source?.launcherClickAction);
  const rawMode = trimValue(source?.launcherClickUrlMode).toLowerCase();
  const customUrl = trimValue(source?.launcherClickUrl);
  const standaloneReturnUrl = trimValue(source?.standaloneReturnUrl);

  if (rawAction === LAUNCHER_CLICK_ACTION_OPEN_WIDGET) {
    return LAUNCHER_CLICK_ACTION_OPEN_WIDGET;
  }

  if (rawAction === LAUNCHER_CLICK_ACTION_OPEN_URL) {
    return LAUNCHER_CLICK_ACTION_OPEN_URL;
  }

  if (
    rawMode === LAUNCHER_CLICK_URL_MODE_DEFAULT ||
    rawMode === LAUNCHER_CLICK_URL_MODE_CUSTOM ||
    customUrl ||
    standaloneReturnUrl
  ) {
    return LAUNCHER_CLICK_ACTION_OPEN_URL;
  }

  return LAUNCHER_CLICK_ACTION_OPEN_WIDGET;
};

export const normalizeBubbleLauncherState = source => ({
  launcherClickAction: resolveLauncherClickAction(source),
  launcherClickUrlMode: resolveLauncherClickUrlMode(source),
  launcherClickOpenInNewTab: !!source?.launcherClickOpenInNewTab,
  launcherClickUrl: trimValue(source?.launcherClickUrl),
  standaloneReturnUrl: trimValue(source?.standaloneReturnUrl),
});

export const serializeBubbleLauncherState = source => {
  const normalized = normalizeBubbleLauncherState(source);

  if (normalized.launcherClickAction !== LAUNCHER_CLICK_ACTION_OPEN_URL) {
    return {
      launcherClickAction: LAUNCHER_CLICK_ACTION_OPEN_WIDGET,
      launcherClickUrlMode: LAUNCHER_CLICK_URL_MODE_DEFAULT,
      launcherClickOpenInNewTab: false,
      launcherClickUrl: '',
      standaloneReturnUrl: '',
    };
  }

  if (normalized.launcherClickUrlMode === LAUNCHER_CLICK_URL_MODE_CUSTOM) {
    return {
      launcherClickAction: LAUNCHER_CLICK_ACTION_OPEN_URL,
      launcherClickUrlMode: LAUNCHER_CLICK_URL_MODE_CUSTOM,
      launcherClickOpenInNewTab: normalized.launcherClickOpenInNewTab,
      launcherClickUrl: normalized.launcherClickUrl,
      standaloneReturnUrl: '',
    };
  }

  return {
    launcherClickAction: LAUNCHER_CLICK_ACTION_OPEN_URL,
    launcherClickUrlMode: LAUNCHER_CLICK_URL_MODE_DEFAULT,
    launcherClickOpenInNewTab: false,
    launcherClickUrl: '',
    standaloneReturnUrl: normalized.standaloneReturnUrl,
  };
};
